import React, { useState, useRef } from "react";
import {
  useStripe,
  useElements,
  AddressElement,
  CardElement,
} from "@stripe/react-stripe-js";

import colors from "../../styles/colors";
import ReCAPTCHA from "react-google-recaptcha";

import StyledCardElement from "./StyledCardElement";
import { Button, TextField } from "@material-ui/core";
import ActionButton from "../../components/common/ActionButton";

const CheckoutForm = (props) => {
  const [showForm, setShowForm] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [name, setName] = useState("");
  const recaptchaRef = React.createRef();
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);

  const handleSubmit = (event) => {
    const recaptchaValue = recaptchaRef.current.getValue();
    event.preventDefault();
    const cardElement = elements.getElement(CardElement);
    stripe.createToken(cardElement, { name: name }).then((data) => {
      props.onSubmit(data.token, recaptchaValue);
    });
  };

  const handleCaptchaChanged = (value) => {
    setSubmitEnabled(true);
    setCaptchaValue(value);
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <p style={{ color: colors.primary }}>Name of Card Holder</p>
          <TextField
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
          <p style={{ color: colors.primary }}>Credit Card Details</p>
          <StyledCardElement />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              justifyContent: "center",
              flex: 1,
              marginTop: 50,
            }}
          >
            <ReCAPTCHA
              sitekey="6LeIc3sqAAAAAPtuuFtj0gkJgeXX4JFmAQ9LjPoR"
              ref={recaptchaRef}
              onChange={handleCaptchaChanged}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              justifyContent: "space-between",
              flex: 1,
              marginTop: 50,
            }}
          >
            <div>
              <img
                style={{ width: 150, marginTop: 10 }}
                src={require("../../resources/images/stripe_logo.png")}
                alt="Stripe Logo"
              />
            </div>
            <ActionButton
              label="Confirm Order"
              onClick={handleSubmit}
              disabled={!submitEnabled}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default CheckoutForm;



// WEBPACK FOOTER //
// ./src/layout/stripe/CheckOutForm.js